"use client"

import { styled } from "@mui/material";
import { PageLayout } from "../pageLayout";

export const StyledIbtroziForRos1 = styled(PageLayout)(({ theme }) => ({
  
}))